import { render } from "./Kemaskini.vue?vue&type=template&id=6d35e6c6"
import script from "./Kemaskini.vue?vue&type=script&lang=js"
export * from "./Kemaskini.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__